export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/promoVideoBg-9bff1ea89520205c30d0dbb685ba0586.png";